import React, { PureComponent } from 'react';
import { create, destroy, read, update } from '../utils/request';
import ruleFetcher from '../utils/rule_fetcher';
import { DataRetentionRulesContext } from './data_retention_rules/context';
import type { Context } from './data_retention_rules/context';
import { DataRetentionRule } from './data_retention_rules/data_retention_rule';
import View from './data_retention_rules/view';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/utils/scrolling'. 'app/webpack/javascripts/shared/utils/scrolling.js' implicitly has an 'any' type.
import { scrollToClass } from 'shared/utils/scrolling';

export const errorClass = '__form-field-error';

type Props = {
  rules_path: string;
};

const scrollToFirstError = () => {
  scrollToClass(errorClass);
};

export default class DataRetentionRules extends PureComponent<Props, Context> {
  state: Context = {
    edited: false,
    editing: false,
    editingRuleId: null,
    errors: {},
    loaded: false,
    meta: {
      all_offices_path: '',
      candidate_data_path: '',
      notifications_path: '',
      update_rules_path: '',
      new_rule_path: '',
      pagination: {
        current_page: null,
        next_page: null,
        per_page: null,
        previous_page: null,
        total_entries: null,
        total_pages: null,
      },
    },
    rules: [],
    notificationOptions: [],
    onGetNotificationData: async () => {
      const response = await read(this.state.meta.notifications_path);
      this.setState(() => ({
        notificationOptions: response.data,
      }));
    },
    onAdd: async () => {
      const response = await read(this.state.meta.new_rule_path);
      this.setState((prevState) => ({
        rules: [
          ...prevState.rules,
          new DataRetentionRule({ ...response.data, enabled: true }),
        ],
        edited: false,
        editing: true,
        editingRuleId: response.data.id,
        errors: {},
      }));
    },
    onCancel: () => {
      // Scroll to top of screen to avoid "jumping" to the bottom
      window.scrollTo(0, 0);

      this.setState((prevState) => ({
        edited: false,
        editing: false,
        editingRuleId: null,
        errors: {},
        rules: prevState.rules.filter((r) => r.id !== null),
      }));
    },
    // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
    onEdit: (rule, clearErrors = true) => {
      // @ts-expect-error - TS2345 - Argument of type '{ errors?: {} | undefined; editing: true; editingRuleId: any; }' is not assignable to parameter of type 'Context | ((prevState: Readonly<Context>, props: Readonly<Props>) => Context | Pick<Context, "errors" | "editing" | "editingRuleId"> | null) | Pick<...> | null'.
      this.setState({
        editing: true,
        editingRuleId: rule.id,
        ...(clearErrors && { errors: {} }),
      });
    },
    // @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
    onFieldChange: (field) => {
      this.setState((prevState) => ({
        edited: true,
        errors: { ...prevState.errors, [field]: null },
      }));
    },
    // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
    onSave: async (rule, maintainPagePosition = false) => {
      try {
        // @ts-expect-error - TS7034 - Variable 'response' implicitly has type 'any' in some locations where its type cannot be determined.
        let response;
        if (!rule.id) {
          response = await create(this.state.meta.update_rules_path, rule, {
            scope: 'data_retention_rule',
          });
        } else {
          response = await update(this.state.meta.update_rules_path, rule, {
            scope: 'data_retention_rule',
          });
        }
        this.setState((prevState) => {
          const rules = [...prevState.rules];
          const updatedRuleIndex = rules.findIndex((r) => r.id === rule.id);
          // @ts-expect-error - TS7005 - Variable 'response' implicitly has an 'any' type.
          rules[updatedRuleIndex] = response.data;

          if (!maintainPagePosition) {
            // Scroll to top of screen to avoid "jumping" to the bottom
            window.scrollTo(0, 0);
          }

          return {
            edited: false,
            editing: false,
            editingRuleId: null,
            errors: {},
            rules,
          };
        });

        return true;
      } catch (error: any) {
        const {
          response: {
            data: { errors },
          },
        } = error;

        this.setState({
          errors,
        });
        if (!maintainPagePosition) {
          scrollToFirstError();
        }

        return false;
      }
    },
    // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
    onDelete: async (rule) => {
      await destroy(this.state.meta.update_rules_path, rule);
      this.setState((prevState) => {
        const rules = prevState.rules.filter((r) => r.id !== rule.id);

        // Scroll to top of screen to avoid "jumping" to the bottom
        window.scrollTo(0, 0);

        return {
          rules,
          edited: false,
          editing: false,
          editingRuleId: null,
          errors: {},
        };
      });
    },
  };

  componentDidMount(): void {
    const { rules_path: rulesPath } = this.props;
    // @ts-expect-error - TS7031 - Binding element 'data' implicitly has an 'any' type. | TS7006 - Parameter 'done' implicitly has an 'any' type.
    ruleFetcher(rulesPath, ({ data }, done) =>
      this.setState((prevState) => ({
        loaded: done,
        meta: data.meta,
        rules: [...prevState.rules, ...data.rules],
      }))
    );
  }

  render() {
    return (
      // @ts-expect-error - TS2322 - Type 'Context' is not assignable to type '{ readonly edited: false; readonly editing: false; readonly editingRuleId: null; readonly errors: {}; readonly loaded: false; readonly meta: { readonly all_offices_path: ""; readonly candidate_data_path: ""; readonly notifications_path: ""; readonly update_rules_path: ""; readonly new_rule_path: ""; readonly paginat...'.
      <DataRetentionRulesContext.Provider value={this.state}>
        <View />
      </DataRetentionRulesContext.Provider>
    );
  }
}
